import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        cockpit: {
            loading: false,
            aircraftName: '',
        },
        user: "",
        completed_procedures: [],
    },
    getters: {
        cockpitLoading(state) {
            return state.cockpit.loading;
        },
    },
    mutations: {
        SET_AIRCRAFT(state, name) {
            state.cockpit.aircraftName = name;
        },
        SET_LOADING(state, status) {
            state.cockpit.loading = status;
        },
        SET_USER(state, name) {
            state.user = name;
            localStorage.setItem('username', name)
        },
        RESET_USER(state) {
            state.user = ''
            state.completed_procedures = []
            localStorage.removeItem('username')
        },
        ADD_COMPLETED_PROCEDURE(state, {aircraft, procedure}) {
           // @ts-ignore
            state.completed_procedures = [...state.completed_procedures, {aircraft: aircraft, procedure: procedure}];
        }

    },
    actions: {
        getUsernameFromStorage({commit}) {
            const username = localStorage.getItem('username');
            if (username) {
                commit('SET_USER', username)
            }
        },
        saveUser({commit}, name) {
            commit('SET_USER', name)
        },
        logOut({commit}, name) {
            commit('RESET_USER')
        },
        addCompletedProcedure({commit}, {aircraft, procedure}){
            commit('ADD_COMPLETED_PROCEDURE', {aircraft, procedure})
        }
    },
    modules: {}
})


